import React from "react";

interface Column {
  key: string;
  header:  React.ReactNode;
  className?: string;
  render?: (value: any, row: any) => React.ReactNode;
}

interface TableProps {
  columns: Column[];
  data: any[];
  className?: string;
  headClassName?: string;
  rowClassName?: string;
  cellClassName?: string;
  onRowClick?: (row: any, rowIndex: number) => void;
}

const Table: React.FC<TableProps> = ({
  columns,
  data,
  className = "ranking-table",
  headClassName = "head",
  rowClassName = "ranking-table-data",
  cellClassName = "ranking-td",
  onRowClick ,
}) => {
  return (
    <table className={className}>
      <thead className={headClassName}>
        <tr>
          {columns.map((col, index) => (
            <th key={index} className={col.className || "font-inter-500-16"}>
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data && data.map((row, rowIndex) => (
          <tr key={rowIndex} className={rowClassName} onClick={() => onRowClick && onRowClick(row, rowIndex)} >
            {columns.map((col, colIndex) => (
              <td key={colIndex} className={col.className || cellClassName}>
                {col.render ? col.render(row[col.key], row) : row[col.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;